// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-modal {
  z-index: var(--elevation-modal);
  justify-content: center;
}

.r-modal {
  display: none;
}

.r-modal--show {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./app/components/AppModal/style.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".app-modal {\n  z-index: var(--elevation-modal);\n  justify-content: center;\n}\n\n.r-modal {\n  display: none;\n}\n\n.r-modal--show {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
